module.exports = __webpack_public_path__ + "img/4. Program_2 - Core Team.053790fe.jpg";